export const FakeParticipant = {
  LocalScreenShare: 'LocalScreenShare',
  RemoteScreenShare: 'RemoteScreenShare',
  SharedVideo: 'SharedVideo',
  Whiteboard: 'Whiteboard'
};
